import React, { useState } from 'react';

import CRMApi from '../../../Api/CRM/CRMApi';
import User from '../../../Api/Models/User';
import Card from '../../elements/common/Card';

import UserForm, { emptyUser } from './UserForm';

function UserCreate() {
    const [user, setUser] = useState<User>(emptyUser);

    return (
        <Card title="Create new user">
            <UserForm action={() => CRMApi.users.store(user)} user={user} setUser={setUser} />
        </Card>
    );
}

export default UserCreate;
